import React from "react";
import LegalPage, { Section, Bullets } from "@/components/LegalPage";

export default function Terms() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Terms of Use"
      intro="Please read these terms — they govern your access to mizizitable.com and your use of the Mizizi digital cookbook."
      updated="February 2026"
    >
      <Section title="Your Mizizi purchase">
        <p>
          When you buy the Mizizi digital cookbook you receive a personal,
          non-transferable licence to read, print and cook from the book for
          your own personal, non-commercial use.
        </p>
      </Section>

      <Section title="What you may do">
        <Bullets items={[
          "Read the book on your own devices, in the online Reader, and by downloading the PDF.",
          "Print a single personal copy for your own kitchen.",
          "Share what you cook — photographs of your finished dish on your own social channels are welcome and encouraged.",
        ]}/>
      </Section>

      <Section title="What you may not do">
        <Bullets items={[
          "Redistribute, resell, republish, upload, or otherwise share the cookbook file, its PDF or its individual recipes with anyone else.",
          "Reproduce the photography, illustrations, layout or typography outside of your personal use.",
          "Use Mizizi content to train machine-learning models or build derivative works without our written permission.",
        ]}/>
      </Section>

      <Section title="Prices, currencies and payments">
        <Bullets items={[
          "Prices are displayed in USD for international buyers and KES for buyers in Kenya. Currency shown depends on the currency toggle on the Shop.",
          "Card payments are processed by Stripe. M-PESA and Kenyan-card payments are processed by Paystack. Applicable taxes are your responsibility unless stated otherwise.",
          "All purchases are subject to the Refund Policy set out on our FAQ & Refund page.",
        ]}/>
      </Section>

      <Section title="Accuracy of information">
        <p>
          We take care to ensure that recipes are original, tested and safely
          worded. However, cooking involves your own judgement — you are
          responsible for choosing ingredients that are safe for your
          household and for following food-safety and appliance guidance in
          your own kitchen. Nothing on this site is medical or nutritional
          advice.
        </p>
      </Section>

      <Section title="Availability">
        <p>
          We aim to keep mizizitable.com online continuously but cannot
          guarantee uninterrupted access. Occasional maintenance windows may
          apply. If you can't reach the Reader when you need it, please
          write to us and we'll help.
        </p>
      </Section>

      <Section title="Changes to these terms">
        <p>
          If we update these terms materially we will refresh the "Last
          updated" date at the top of this page and — for significant
          changes — email registered customers to flag what changed.
        </p>
      </Section>

      <Section title="Contact">
        <p>
          Questions about these terms? Write to{" "}
          <a href="mailto:hello@mizizitable.com" className="text-mizizi-terracotta underline underline-offset-4 hover:text-mizizi-gold">
            hello@mizizitable.com
          </a>
          . We aim to reply within 1–2 business days.
        </p>
      </Section>
    </LegalPage>
  );
}
